/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Container, Box, Flex, Heading } from "theme-ui";
import ContentfulRichText from "../../shared/ContentfulRichText";
import HubspotForm from 'react-hubspot-form';
import useSanitizeHtml from "../../../hooks/useSanitizeHtml";

export const query = graphql`
  fragment ContentfulCustomHtmlFragment on ContentfulCustomHtml {
    htmlContents {
        htmlContents
      }  
    formId
    portalId
    description {
        raw
      }
    heading
  }
`;

export default function CustomHTML({ sectionContent }) {
    const { description, htmlContents,formId, portalId, heading } = sectionContent;
    const rawHtml = htmlContents ? htmlContents.htmlContents : '';
    const sanitizedHtml = useSanitizeHtml(rawHtml, true);

    return(
      <Flex mb={5} sx={{ padding: ["0", 0 ,"30px"], margin: ["0 auto 30px auto","0 auto 30px auto"], borderRadius: '20px', justifyContent: ['center', 'space-between'], flexDirection: ['column', 'column'] }}>
        <Container>
          <Box sx={{ width: ['100%', '100%'], maxWidth: '500px', paddingRight: [3, 20] }}>
            {heading && (
              <Heading as={'h5'} variant="extraBold" sx={{ color: 'inherit', paddingTop: '20px' }}>
                {heading}
              </Heading>
            )}
            {description &&
              <Box sx={{ color: 'white' }}>
                <ContentfulRichText richText={description} fontColor={'#404041'} />
              </Box>
            }
          </Box>
        </Container>
        <Box className={`html-wrapper`} >
          <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        </Box>
        {formId &&
          <Container>
            <Flex className="hubspot-form" sx={{justifyContent: 'center', width: "100%"}}>
                <HubspotForm
                  portalId={portalId}
                  formId={formId}
                  onSubmit={() => console.log('Submit!')}
                  onReady={(form) => console.log('Form ready!')}
                  loading={<div>Loading...</div>}
                />
            </Flex>
          </Container>
        }
      </Flex>
    )
};
